import React from "react";
import Select from "react-select";
import { usePenilaianKaryawan } from "./usePenilaianKaryawan";
import { bulan, tahun } from "../../util/constant";
import AccordionPenilaianKaryawan from "../../components/AccordionPenilaianKaryawan/AccordionPenilaianKaryawan";
import "./PenilaianKaryawan.css";

export default function PenilaianKaryawan() {
  const {
    dataUser,
    reFormat,
    operatorPick,
    setOperatorPick,
    data,
    setData,
    dataRekapitulasi,
    handleKirimPenilaianKaryawan,
    subMenu,
    setSubMenu,
    filterBulan,
    setFilterBulan,
    filterTahun,
    setFilterTahun,
    listPenilaian,
    rekomendasi,
    setRekomendasi,
    category,
    setCategory,
  } = usePenilaianKaryawan();

  const bulanKontrak = data?.bulanKontrak || 0;
  const targetSS = Math.floor(bulanKontrak / 3);
  const totalApprove = dataRekapitulasi?.totalApprove || 0;

  let nilaiSS = 0;

  if (targetSS <= 0) {
    nilaiSS = 100;
  } else if (totalApprove >= targetSS) {
    nilaiSS = 100;
  } else {
    nilaiSS = (totalApprove / targetSS) * 100;
  }

  return (
    <div className="container_dashboard">
      <div className="wrapper_sub_menu_ss">
        <p
          className={
            subMenu === "Input" ? "sub_menu_ss border_active_ss" : "sub_menu_ss"
          }
          onClick={() => setSubMenu("Input")}
        >
          Input
        </p>
        <p
          className={
            subMenu === "Habis Kontrak"
              ? "sub_menu_ss border_active_ss"
              : "sub_menu_ss"
          }
          onClick={() => setSubMenu("Habis Kontrak")}
        >
          Habis Kontrak
        </p>
        <p
          className={
            subMenu === "Tahunan"
              ? "sub_menu_ss border_active_ss"
              : "sub_menu_ss"
          }
          onClick={() => setSubMenu("Tahunan")}
        >
          Tahunan
        </p>
      </div>
      {subMenu === "Input" ? (
        <>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "12px" }}>
            <div className="wrapper-pilih-nama-penilaian font-14-mobile-penilaian">
              <p
                className="font-14-mobile-penilaian"
                style={{ fontWeight: 600 }}
              >
                Nama
              </p>
              <Select
                placeholder="Pilih Operator"
                options={reFormat}
                value={operatorPick || ""}
                onChange={setOperatorPick}
              />
            </div>
            <div>
              <p
                className="font-14-mobile-penilaian"
                style={{ fontWeight: 600 }}
              >
                Bulan Kontrak
              </p>
              <input
                className="input-penilaian"
                type="number"
                value={data.bulanKontrak || ""}
                onChange={(e) =>
                  setData((prev) => ({
                    ...prev,
                    bulanKontrak: Number(e.target.value),
                  }))
                }
                onWheel={(e) => e.target.blur()}
              />
            </div>
            <div>
              <p
                className="font-14-mobile-penilaian"
                style={{ fontWeight: 600 }}
              >
                Rajin
              </p>
              <input
                className="input-penilaian"
                type="number"
                value={data.rajin || ""}
                onChange={(e) =>
                  setData((prev) => ({
                    ...prev,
                    rajin: Number(e.target.value),
                  }))
                }
                onWheel={(e) => e.target.blur()}
              />
            </div>
            <div>
              <p
                className="font-14-mobile-penilaian"
                style={{ fontWeight: 600 }}
              >
                Taat
              </p>
              <input
                className="input-penilaian"
                type="number"
                value={data.taat || ""}
                onChange={(e) =>
                  setData((prev) => ({
                    ...prev,
                    taat: Number(e.target.value),
                  }))
                }
                onWheel={(e) => e.target.blur()}
              />
            </div>
            <div>
              <p
                className="font-14-mobile-penilaian"
                style={{ fontWeight: 600 }}
              >
                Hasil
              </p>
              <input
                className="input-penilaian"
                type="number"
                value={data.hasil || ""}
                onChange={(e) =>
                  setData((prev) => ({
                    ...prev,
                    hasil: Number(e.target.value),
                  }))
                }
                onWheel={(e) => e.target.blur()}
              />
            </div>
            <div>
              <p
                className="font-14-mobile-penilaian"
                style={{ fontWeight: 600 }}
              >
                Sikap
              </p>
              <input
                className="input-penilaian"
                type="number"
                value={data.sikap || ""}
                onChange={(e) =>
                  setData((prev) => ({
                    ...prev,
                    sikap: Number(e.target.value),
                  }))
                }
                onWheel={(e) => e.target.blur()}
              />
            </div>
            <div>
              <p
                className="font-14-mobile-penilaian"
                style={{ fontWeight: 600 }}
              >
                Pelanggaran
              </p>
              <input
                className="input-penilaian"
                type="number"
                value={data.pelanggaran || ""}
                onChange={(e) =>
                  setData((prev) => ({
                    ...prev,
                    pelanggaran: Number(e.target.value),
                  }))
                }
                onWheel={(e) => e.target.blur()}
              />
            </div>
            {dataUser.tim === 1 ? (
              <div>
                <p
                  className="font-14-mobile-penilaian"
                  style={{ fontWeight: 600 }}
                >
                  Nilai SS
                </p>
                <input
                  className="input-penilaian"
                  type="number"
                  value={nilaiSS}
                  disabled
                  onWheel={(e) => e.target.blur()}
                />
              </div>
            ) : (
              ""
            )}
            {dataRekapitulasi && dataRekapitulasi.totalPending ? (
              <div>
                <p
                  className="font-14-mobile-penilaian"
                  style={{ fontWeight: 600 }}
                >
                  SS Pending
                </p>
                <input
                  className="input-penilaian"
                  type="number"
                  value={dataRekapitulasi?.totalPending}
                  disabled
                  onWheel={(e) => e.target.blur()}
                />
              </div>
            ) : (
              ""
            )}
          </div>
          <br />
          {/* Show jumlah sesuai H - Kontrak S,I,A dan SS */}
          <div>
            <p className="title-absensi">Absensi</p>
            <div style={{ display: "flex", flexWrap: "wrap", gap: "12px" }}>
              <div>
                <p
                  className="font-14-mobile-penilaian"
                  style={{ fontWeight: 600 }}
                >
                  Sakit
                </p>
                <input
                  className="input-penilaian"
                  type="number"
                  value={
                    dataRekapitulasi?.hariSakit + dataRekapitulasi?.suratDokter
                  }
                  disabled
                  onWheel={(e) => e.target.blur()}
                />
              </div>
              <div>
                <p
                  className="font-14-mobile-penilaian"
                  style={{ fontWeight: 600 }}
                >
                  Izin
                </p>
                <input
                  className="input-penilaian"
                  type="number"
                  value={
                    (dataRekapitulasi?.hariIzin || 0) +
                    (dataRekapitulasi?.hariIzinChecked || 0) +
                    Math.floor(dataRekapitulasi?.setengahHariIzin || 0)
                  }
                  disabled
                  onWheel={(e) => e.target.blur()}
                />
              </div>
              <div>
                <p
                  className="font-14-mobile-penilaian"
                  style={{ fontWeight: 600 }}
                >
                  Alpha
                </p>
                <input
                  className="input-penilaian"
                  type="number"
                  value={dataRekapitulasi?.alpha}
                  disabled
                  onWheel={(e) => e.target.blur()}
                />
              </div>
            </div>
          </div>
          <div style={{ display: "flex", gap: "12px" }}>
            <div>
              <p>Kategori</p>
              <select
                value={category}
                style={{ height: "32px" }}
                onChange={(e) => setCategory(e.target.value)}
              >
                <option disabled>Kategori</option>
                <option value="Habis">Habis Kontrak</option>
                <option value="Tahunan">Penilaian Tahunan</option>
              </select>
            </div>
            {category === "Habis" ? (
              <div>
                <p>Rekomendasi</p>
                <select
                  value={rekomendasi}
                  style={{ height: "32px" }}
                  onChange={(e) => setRekomendasi(e.target.value)}
                >
                  <option disabled>Rekomendasi</option>
                  <option value="yes">Diperpanjang</option>
                  <option value="no">Tidak Diperpanjang</option>
                </select>
              </div>
            ) : (
              ""
            )}
          </div>
          <br />
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <button
              className="button-kirim-penilaian"
              onClick={() => handleKirimPenilaianKaryawan()}
            >
              Kirim
            </button>
          </div>
        </>
      ) : (
        <>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
            }}
          >
            {subMenu !== "Tahunan" ? (
              <select
                style={{ marginRight: "6px", marginBottom: "6px" }}
                className="select-filter-bulan-tahun"
                defaultValue="Bulan"
                onChange={(e) => setFilterBulan(e.target.value)}
                value={filterBulan}
              >
                <option selected disabled>
                  Bulan
                </option>
                {bulan.map((ele) => (
                  <option value={Number(ele.value)}>{ele.name}</option>
                ))}
              </select>
            ) : (
              ""
            )}
            <select
              className="select-filter-bulan-tahun"
              defaultValue="Tahun"
              onChange={(e) => setFilterTahun(e.target.value)}
              style={{ marginRight: "12px", marginBottom: "6px" }}
              value={filterTahun}
            >
              <option selected disabled>
                Tahun
              </option>
              {tahun.map((ele) => (
                <option value={ele}>{ele}</option>
              ))}
            </select>
          </div>
          <div>
            <AccordionPenilaianKaryawan
              data={listPenilaian && listPenilaian}
              tim={dataUser.tim}
            />
          </div>
        </>
      )}
    </div>
  );
}
